import { HttpMethod } from '../constants/enum';
import HiggsPromise from '../utils/higgsPromise';

/* 登录请求
 * POST请求, data为传递给后台的参数, 其他参数使用请查看HiggsPromise对象
 */
export function test(data) {
    return HiggsPromise({
        url: '/common/contacts',
        type: HttpMethod.POST,
        data: data
    });
}

/* 登录请求
 * GET请求, data为传递给后台的参数, 其他参数使用请查看HiggsPromise对象
 */
export function login(data) {
    return HiggsPromise({
        url: '/user/login',
        type: HttpMethod.GET,
        data: data
    });
}

/* 登出请求
 * GET请求, data为传递给后台的参数, 其他参数使用请查看HiggsPromise对象
 */
export function logout() {
    return HiggsPromise({
        url: '/user/logout',
        type: HttpMethod.POST
    });
}



// WEBPACK FOOTER //
// ./src/services/login.js